import { render } from "./OperatorsTable.vue?vue&type=template&id=81cf4756&ts=true"
import script from "./OperatorsTable.vue?vue&type=script&lang=tsx"
export * from "./OperatorsTable.vue?vue&type=script&lang=tsx"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__